/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the percent increase between two values`)
};

const es_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halla el aumento porcentual entre dos valores`)
};

const de_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den prozentualen Anstieg zwischen zwei Werten ermitteln`)
};

const nl_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de percentagestijging tussen twee waarden`)
};

const fr_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez l'augmentation en pourcentage entre deux valeurs`)
};

const it_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova l'aumento percentuale tra due valori`)
};

const pt_br2_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre o aumento percentual entre dois valores`)
};

const pt_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o aumento percentual entre dois valores`)
};

const ja_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの値の間のパーセント増加を求める`)
};

const zh_pct_nav_increase_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算两个数值之间的百分比增长`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_nav_increase_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_nav_increase_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_nav_increase_desc", locale)
	if (locale === "en") return en_pct_nav_increase_desc(inputs)
	if (locale === "es") return es_pct_nav_increase_desc(inputs)
	if (locale === "de") return de_pct_nav_increase_desc(inputs)
	if (locale === "nl") return nl_pct_nav_increase_desc(inputs)
	if (locale === "fr") return fr_pct_nav_increase_desc(inputs)
	if (locale === "it") return it_pct_nav_increase_desc(inputs)
	if (locale === "pt-BR") return pt_br2_pct_nav_increase_desc(inputs)
	if (locale === "pt") return pt_pct_nav_increase_desc(inputs)
	if (locale === "ja") return ja_pct_nav_increase_desc(inputs)
	return zh_pct_nav_increase_desc(inputs)
};